<template>
  <ul>
    <li v-for="item in strArray" :key="item.url">
      <p>
        {{ $t(item.text) }}:
        <template v-if="item.key === 'url'">
          <span>{{ pathFn(rowData.scopeName, rowData.sceneName) }}</span>
        </template>
        <span v-else-if="!item.isFunc">{{ rowData[item.key] }}</span>
        <span v-else>{{ FuncFn(item.key, rowData[item.key]) }}</span>
      </p>
    </li>
  </ul>
</template>

<script>
import {
  configStatusConvert,
  equiStatusConvert,
  gatewayTypeConvert
} from '@/utils/convert'

export default {
  props: ['rowData', 'typeWay'],
  data () {
    return {
      strArray: [
        {
          text: 'public.belong',
          key: 'url'
        },
        {
          text: 'public.carrier',
          key: 'carrierName',
          isFunc: true
        },
        {
          text: 'device.gateway_name',
          key: 'name'
        },
        {
          text: 'device.gateway_mac',
          key: 'mac'
        },
        {
          text: 'device.gateway_type',
          key: 'type',
          isFunc: true
        },
        {
          text: 'device.gateway_status',
          key: 'status',
          isFunc: true
        },
        {
          text: 'device.config_status',
          key: 'configStatus',
          isFunc: true
        },
        {
          text: 'public.table_create_time',
          key: 'createTime',
          isFunc: true
        },
        {
          text: $t('integration.gateway_deactivation_time'),
          key: 'updateTime',
          isFunc: true
        }
      ]
    }
  },
  mounted () {
    if (this.typeWay === 'stop') {
      this.strArray.splice(1, 1)
      this.strArray.splice(4, 3)
    }
    if (this.typeWay === 'bind' || this.typeWay === 'unbind') {
      this.strArray.pop()
    }
    if (this.typeWay === 'unbind') {
      this.strArray.splice(1, 1)
    }
    if (this.typeWay === 'unknown') {
      this.strArray = [
        {
          text: 'public.belong',
          key: 'url'
        },
        {
          text: 'device.gateway_name',
          key: 'name'
        },
        {
          text: 'device.gateway_mac',
          key: 'mac'
        },
        {
          text: 'device.gateway_type',
          key: 'type',
          isFunc: true
        },
        {
          text: 'public.table_create_time',
          key: 'createTime',
          isFunc: true
        }
      ]
    }
  },
  methods: {
    FuncFn (key, value) {
      switch (key) {
        case 'type': {
          return this.$t(gatewayTypeConvert(value)?.title || '')
        }
        case 'status': {
          return this.$t(equiStatusConvert(value)?.title || '')
        }
        case 'configStatus': {
          return this.$t(configStatusConvert(value)?.title || '')
        }
        case 'createTime': {
          return this.$timetransition(value)
        }
        case 'updateTime': {
          return this.$timetransition(value)
        }
        case 'carrierName': {
          return this.carrierFn(value)
        }
        default:
          break
      }
    },
    carrierFn (carrierName) {
      if (!carrierName) return
      const array = carrierName.split(',')
      return array
        .map(item => {
          const newArray = item.split('-')
          return newArray[newArray.length - 1]
        })
        .join(',')
    },
    pathFn (scopePath, sencePath) {
      if (!sencePath) return scopePath
      return scopePath + `-[${sencePath}]`
    }
  }
}
</script>

<style></style>
